<template>
  <SideBarLayoutContent>
    <template #top-bar>
      <h1 class="text-display-small grow">{{ $t('mainNavigation.assessments') }}</h1>
      <BaseTextButton color="tonal" size="M" icon="add" @click="openCreateDialog">{{
        $t('common.startAssessment')
      }}</BaseTextButton>
    </template>
    <LoadingWrapper :state="status">
      <ul v-if="assessments.length" class="flex flex-col gap-0.5">
        <li
          v-for="assessment in assessments"
          :key="assessment.id"
          class="first:[&>div]:rounded-t-large last:[&>div]:rounded-b-large"
        >
          <AssessmentPreviewItem :assessment="assessment" />
        </li>
      </ul>
      <EmptyPage
        v-else
        :title="$t('coaching.assessment.empty.title')"
        :description="$t('coaching.assessment.empty.description')"
        icon="assignment"
      >
        <BaseTextButton color="tonal" size="M" icon="add" @click="openCreateDialog">{{
          $t('common.startAssessment')
        }}</BaseTextButton>
      </EmptyPage>
    </LoadingWrapper>
  </SideBarLayoutContent>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import SideBarLayoutContent from '@/core/components/layouts/SideBarLayoutContent.vue'
  import LoadingWrapper from '@/core/components/loading/LoadingWrapper.vue'
  import EmptyPage from '@/core/components/empty-states/EmptyPage.vue'
  import { useAssessments } from '../components/use-assessments'
  import AssessmentPreviewItem from './AssessmentPreviewItem.vue'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import { useRouter } from 'vue-router'

  const router = useRouter()

  const { data, status } = useAssessments()
  const assessments = computed(() => data.value ?? [])

  const openCreateDialog = () => {
    router.push({
      query: {
        startAssessment: 'true',
      },
    })
  }
</script>
